var render = function () {
  var _vm$currentHasilRanki, _vm$currentHasilRanki2, _vm$currentHasilRanki3;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', [_c('h3', {
    staticClass: "text-primary text-center mb-2"
  }, [_vm._v("Ranking SNBP")]), _vm.myRanking ? _c('b-row', {
    staticClass: "justify-content-center"
  }, [_c('b-col', {
    attrs: {
      "cols": "6",
      "sm": "6",
      "md": "4",
      "lg": "3"
    }
  }, [_c('b-card', {
    staticClass: "bg-primary mt-3"
  }, [_c('section', {
    staticClass: "d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_c('feather-icon', {
    staticClass: "text-light",
    attrs: {
      "size": "60",
      "icon": "BarChart2Icon"
    }
  })], 1), _c('div', [_c('h4', {
    staticClass: "media-heading text-white"
  }, [_c('b', [_vm._v(" Rank Saya")])]), _c('span', {
    staticClass: "text-white"
  }, [_c('b', [_vm._v(" " + _vm._s(_vm.myRanking.ranking.ke))]), _vm._v("/" + _vm._s(_vm.myRanking.ranking.dari) + " ")])])])])], 1)], 1) : _vm._e(), _c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Top 10 Rank")]), _c('b-row', {
    staticClass: "mt-4"
  }, [_c('b-col', {
    attrs: {
      "md": "4",
      "sm": "4"
    }
  }, [_c('label', [_vm._v("Filter Jurusan")]), _c('v-select', {
    staticClass: "select-size-sm w-full",
    attrs: {
      "label": "text",
      "clearable": true,
      "options": _vm.optJurusan
    },
    on: {
      "input": function input($event) {
        return _vm.getRanking();
      }
    },
    model: {
      value: _vm.filterJurusan,
      callback: function callback($$v) {
        _vm.filterJurusan = $$v;
      },
      expression: "filterJurusan"
    }
  })], 1), _c('b-col', {
    attrs: {
      "md": "2",
      "sm": "2"
    }
  }), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filter Berdasarkan Sekolah Anda?",
      "label-for": "filter"
    }
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    on: {
      "input": function input($event) {
        return _vm.getRanking();
      }
    },
    model: {
      value: _vm.filterSekolah,
      callback: function callback($$v) {
        _vm.filterSekolah = $$v;
      },
      expression: "filterSekolah"
    }
  })], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3",
      "sm": "3"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Filter Berdasarkan Provinsi Anda?",
      "label-for": "filter"
    }
  }, [_c('b-form-group', [_c('b-form-checkbox', {
    attrs: {
      "switch": "",
      "inline": ""
    },
    on: {
      "input": function input($event) {
        return _vm.getRanking();
      }
    },
    model: {
      value: _vm.filterProvinsi,
      callback: function callback($$v) {
        _vm.filterProvinsi = $$v;
      },
      expression: "filterProvinsi"
    }
  })], 1)], 1)], 1), _c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('table', {
    staticClass: "table table-bordered responsive"
  }, [_c('tr', {
    staticClass: "bg-primary text-white",
    attrs: {
      "variant": "primary"
    }
  }, [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "3%"
    }
  }, [_vm._v("Rank")]), _c('th', [_vm._v("Nama")]), _c('th', [_vm._v("Target Jurusan 1")]), _c('th', [_vm._v("Target Jurusan 2")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Skor")]), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Hasil")])]), _vm._l(_vm.snbpranking, function (item, i) {
    var _item$majors$, _item$majors$$major, _item$majors$2, _item$majors$2$major;

    return _c('tr', {
      key: i
    }, [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "3%"
      }
    }, [_vm._v(" " + _vm._s(item.ranking.ke) + " ")]), _c('td', [_vm._v(_vm._s(item.name))]), _c('td', [item.majors[0] ? _c('span', [_vm._v(" " + _vm._s((_item$majors$ = item.majors[0]) === null || _item$majors$ === void 0 ? void 0 : (_item$majors$$major = _item$majors$.major) === null || _item$majors$$major === void 0 ? void 0 : _item$majors$$major.name) + " ")]) : _c('i', {
      staticClass: "text-danger"
    }, [_vm._v(" Tidak ada ")])]), _c('td', [item.majors[1] ? _c('span', [_vm._v(" " + _vm._s((_item$majors$2 = item.majors[1]) === null || _item$majors$2 === void 0 ? void 0 : (_item$majors$2$major = _item$majors$2.major) === null || _item$majors$2$major === void 0 ? void 0 : _item$majors$2$major.name) + " ")]) : _c('i', {
      staticClass: "text-danger"
    }, [_vm._v(" Tidak ada ")])]), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', [_vm._v(_vm._s(item === null || item === void 0 ? void 0 : item.nilai_akhir))])]), _c('td', {
      staticClass: "text-center"
    }, [_vm.isMyResult(item) ? _c('feather-icon', {
      staticClass: "text-primary cursor-pointer",
      attrs: {
        "size": "24",
        "icon": "EyeIcon"
      },
      on: {
        "click": function click($event) {
          $event.preventDefault();
          return _vm.viewDetailRanking(item);
        }
      }
    }) : _vm._e()], 1)]);
  })], 2)])], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-detail-ranking",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "xl"
    }
  }, [(_vm$currentHasilRanki = _vm.currentHasilRanking) !== null && _vm$currentHasilRanki !== void 0 && _vm$currentHasilRanki.majors && ((_vm$currentHasilRanki2 = _vm.currentHasilRanking) === null || _vm$currentHasilRanki2 === void 0 ? void 0 : _vm$currentHasilRanki2.majors.length) > 0 ? _c('b-row', _vm._l((_vm$currentHasilRanki3 = _vm.currentHasilRanking) === null || _vm$currentHasilRanki3 === void 0 ? void 0 : _vm$currentHasilRanki3.majors, function (major, i) {
    var _major$major, _major$major2, _major$major3, _major$major4, _major$description, _major$description2, _major$description3, _major$description4;

    return _c('b-col', {
      key: i,
      attrs: {
        "lg": "12",
        "xl": "6"
      }
    }, [_c('section', {
      staticClass: "p-1"
    }, [_c('h2', {
      staticClass: "text-center bg-primary text-white py-1 mb-2"
    }, [_vm._v(" Pilihan Ke " + _vm._s(major === null || major === void 0 ? void 0 : major.pilihan_ke) + " ")]), _c('table', {
      staticClass: "table table-bordered"
    }, [_c('tr', [_c('td', [_vm._v("Target Jurusan")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : (_major$major = major.major) === null || _major$major === void 0 ? void 0 : _major$major.name))])]), _c('td', [_vm._v("Passing Grade")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : (_major$major2 = major.major) === null || _major$major2 === void 0 ? void 0 : _major$major2.passing_grade))])])]), _c('tr', [_c('td', [_vm._v("Daya Tampung")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : (_major$major3 = major.major) === null || _major$major3 === void 0 ? void 0 : _major$major3.daya_tampung))])]), _c('td', [_vm._v("Peminat")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : (_major$major4 = major.major) === null || _major$major4 === void 0 ? void 0 : _major$major4.peminat))])])]), _c('tr', [_c('td', [_vm._v("Nilai Rata-Rata Raport")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : major.nilai_raport_average))])]), _c('td', [_vm._v("Nilai Mapel Pendukung")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : major.nilai_mapel_pendukung))])])]), _c('tr', [_c('td', [_vm._v("Nilai Piagam")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : major.nilai_piagam))])]), _c('td', [_vm._v("Jumlah Alumni")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : major.sum_alumni))])])]), _c('tr', [_c('td', [_vm._v("Nilai Awal")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : major.nilai_awal))])]), _c('td', [_vm._v("Nilai Akhir")]), _c('td', [_c('strong', [_vm._v(_vm._s(major === null || major === void 0 ? void 0 : major.nilai_akhir))])])]), (_major$description = major.description) !== null && _major$description !== void 0 && _major$description.filter_by_sekolah ? _c('tr', [_c('td', [_vm._v("Ket Filter Sekolah")]), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s((_major$description2 = major.description) === null || _major$description2 === void 0 ? void 0 : _major$description2.filter_by_sekolah)
      }
    })])]) : _vm._e(), (_major$description3 = major.description) !== null && _major$description3 !== void 0 && _major$description3.filter_by_provinsi ? _c('tr', [_c('td', [_vm._v("Ket Filter Provinsi")]), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s((_major$description4 = major.description) === null || _major$description4 === void 0 ? void 0 : _major$description4.filter_by_provinsi)
      }
    })])]) : _vm._e()])])]);
  }), 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }